import { FaExchangeAlt, FaLongArrowAltLeft } from "react-icons/fa";
import Sidebar from "./Sidebar";
import { IoSettingsOutline } from "react-icons/io5";
import { Link } from "react-router-dom";
import { AiFillSound } from "react-icons/ai";
import { BsTranslate } from "react-icons/bs";
import { BiCopy } from "react-icons/bi";
import { useEffect, useState } from "react";
import pinyin from "pinyin";
import { toRomaji } from "wanakana";
import { convert as romanize } from "hangul-romanization";
import { transliterate } from "transliteration";
import axios from "axios";

export default function Translator() {

    const [languages, setLanguages] = useState([]);
    const [fromLang, setFromLang] = useState("auto");
    const [toLang, setToLang] = useState("en");

    const [inputText, setInputText] = useState("");
    const [charCount, setCharCount] = useState(0);
    const [translatedText, setTranslatedText] = useState("");
    const [readableText, setReadableText] = useState("");

    const [theme, setTheme] = useState(localStorage.getItem("theme") || "dark");

    useEffect(() => {
        const savedTheme = localStorage.getItem("theme") || "dark";
        setTheme(savedTheme);
    }, []);

    const pageBg = theme === "dark" ? "dashboard-bg" : "bg-light";
    const cardBg = theme === "dark" ? "backgroundd-bg text-light" : "bg-white text-dark";
    const inputBg = theme === "dark" ? "bg-dark text-light" : "bg-light text-dark";
    const btnSecondary = theme === "dark" ? "btn btn-dark text-light" : "btn btn-gradientss text-light";
    const btnMain = theme === "dark" ? "btn btn-gradient text-light" : "btn btn-gradientss text-light";
    const textColor = theme === "dark" ? "text-light" : "text-dark";

    const LANGUAGES = [
        { code: "en", name: "English" },
        { code: "hi", name: "Hindi" },
        { code: "es", name: "Spanish" },
        { code: "fr", name: "French" },
        { code: "de", name: "German" },
        { code: "it", name: "Italian" },
        { code: "pt", name: "Portuguese" },
        { code: "ru", name: "Russian" },
        { code: "ja", name: "Japanese" },
        { code: "ko", name: "Korean" },
        { code: "zh", name: "Chinese" },
        { code: "ar", name: "Arabic" }
    ];

    const NEEDS_READABLE = ["zh", "ja", "ko", "ru", "ar", "hi"];

    useEffect(() => {
        setLanguages(LANGUAGES);

        const savedLang = localStorage.getItem("defaultLanguage");
        if (savedLang) setToLang(savedLang);

    }, []);

    function swapnow() {
        if (fromLang === "auto") return;

        setFromLang(toLang);
        setToLang(fromLang);
        setInputText(translatedText);
        setTranslatedText(inputText);
        setReadableText("");
    }

    function speakText(text, lang) {
        if (!text) return;

        const speech = new SpeechSynthesisUtterance(text);
        speech.lang = lang;
        window.speechSynthesis.cancel();
        window.speechSynthesis.speak(speech);
    }

    function makeReadable(text, lang) {

        switch (lang) {

            case "zh":
                return pinyin(text, { style: pinyin.STYLE_TONE }).flat().join(" ");

            case "ja":
                return toRomaji(text);

            case "ko":
                return romanize(text);

            case "ru":
            case "ar":
            case "hi":
                return transliterate(text);

            default:
                return "";
        }
    }

    function translateText() {

        if (!inputText.trim()) return;

        const sourceLang = fromLang === "auto" ? "en" : fromLang;

        axios.get("https://api.mymemory.translated.net/get", {
            params: {
                q: inputText,
                langpair: `${sourceLang}|${toLang}`,
            },
        })
            .then((response) => {

                const translated = response.data?.responseData?.translatedText;

                if (!translated) {
                    setTranslatedText("Translation failed");
                    return;
                }

                setTranslatedText(translated);

                if (NEEDS_READABLE.includes(toLang))
                    setReadableText(makeReadable(translated, toLang));
                else
                    setReadableText("");

            })
            .catch(() => {
                setTranslatedText("Network error");
            });
    }

    function copyTranslation() {
        if (!translatedText) return;
        navigator.clipboard.writeText(translatedText);
    }

    return (
        <>
            <title>Translate Languages Instantly – Free Online Translator | TravelToolkit</title>
            <meta name="description" content="Translate any language instantly with TravelToolkit. Fast, accurate and easy online translator for travelers. Convert words, sentences and phrases across multiple languages in seconds." />
            <meta name="keywords" content="online translator, language translator, translate languages online, free translator tool, instant translation app, translate text online, travel translator app, multi language translator, translate words and sentences, best translator for travelers" />

            <meta property="og:title" content="Translate Languages Instantly – Free Online Translator | TravelToolkit" />
            <meta property="og:site_name" content="traveltoolkit" />
            <meta property="og:url" content="https://traveltoolkit.online/Translator" />
            <meta property="og:description" content="Translate any language instantly with TravelToolkit. Fast, accurate and easy online translator for travelers. Convert words, sentences and phrases across multiple languages in seconds." />
            <meta property="og:image" content="earth.gif"></meta>

            <meta name="twitter:card" content="app" />
            <meta name="twitter:site" content="@traveltoolkit" />
            <meta name="twitter:description" content="Translate any language instantly with TravelToolkit. Fast, accurate and easy online translator for travelers. Convert words, sentences and phrases across multiple languages in seconds." />
            <meta name="twitter:app:country" content="India" />

            <div className="container-fluid p-0">
                <div className="row g-0">
                    <Sidebar />
                    <div className={`col-md-9 col-lg-10 ${pageBg} min-vh-100 p-3 offset-lg-2 offset-md-2`}>
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <div className="d-flex align-items-center gap-2">
                                <Link to="/Dashboard">
                                    <button className={btnSecondary}>
                                        <FaLongArrowAltLeft size={20} />
                                    </button>
                                </Link>
                                <h1 className={`${textColor} mb-0 h4`}>Translator</h1>
                            </div>
                            <Link to="/Settings">
                                <button className="btn btn-gradientss text-light">
                                    <IoSettingsOutline />
                                </button>
                            </Link>
                        </div>
                        <div className={`card ${cardBg} mb-2`}>
                            <div className="row align-items-center p-3">
                                <div className="col-md-5">
                                    <label className={textColor}>From</label>
                                    <select className={`form-select ${inputBg}`} value={fromLang} onChange={(e) => setFromLang(e.target.value)} >
                                        <option value="auto">Auto Detect</option>
                                        {languages.map((lang) => (
                                            <option key={lang.code} value={lang.code}>
                                                {lang.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <div className="col-md-2 text-center mt-3">
                                    <button className={btnSecondary} onClick={swapnow}>
                                        <FaExchangeAlt />
                                    </button>
                                </div>
                                <div className="col-md-5">
                                    <label className={textColor}>To</label>
                                    <select className={`form-select ${inputBg}`} value={toLang} onChange={(e) => setToLang(e.target.value)}>
                                        {languages.map((lang) => (
                                            <option key={lang.code} value={lang.code}>
                                                {lang.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className={`card ${cardBg} p-3 mb-2`}>
                            <label className={textColor}>Enter text to translate</label>
                            <textarea className={`form-control ${inputBg} mb-2`} rows="4" maxLength={500} value={inputText} onChange={(e) => {
                                setInputText(e.target.value);
                                setCharCount(e.target.value.length);
                            }} />
                            <div className="d-flex justify-content-between">
                                <button className={btnSecondary} onClick={() => speakText(inputText, fromLang === "auto" ? "en" : fromLang)}>
                                    <AiFillSound />
                                </button>
                                <small className={textColor}>{charCount} characters</small>
                            </div>
                        </div>
                        <button className={`btn ${btnMain} w-100 mb-2`} onClick={translateText}>
                            <BsTranslate /> Translate
                        </button>
                        <div className={`card ${cardBg} p-3`}>
                            <label className={textColor}>Translation</label>
                            <div className={`form-control ${inputBg} p-3 mb-2`} style={{ minHeight: "120px" }}>
                                <div className="fs-5">{translatedText}</div>
                                {readableText && (
                                    <div className="text-secondary fst-italic mt-1">
                                        {readableText}
                                    </div>
                                )}
                            </div>
                            <div className="d-flex justify-content-between">
                                <button className={btnSecondary} onClick={() => speakText(translatedText, toLang)}>
                                    <AiFillSound />
                                </button>
                                <button className={btnSecondary} onClick={copyTranslation}>
                                    <BiCopy />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}